import React, { useState } from 'react';
import { DateInput } from "react-admin";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Zemen from "zemen";
import { useController } from 'react-hook-form';
const EthiopianDateInput = props => {

    const {source} = props;
    const {
        field: { name, onChange, value },
    } = useController({ name: source });

   // console.log(value)
    const [ecDate,setEcDate] = useState('');
    React.useEffect(() => {
       if(value)setEcDate(Zemen.toEC(value).toString())
    }, [value]);

    function convertToGC(e) {
        if(e.target.value) {
            const gcDate = Zemen.toGC(e.target.value)
            onChange(gcDate.toDateString());
        }
    }

    function convertToEC(e) {
     //   console.log(e)
     setEcDate(Zemen.toEC(e.target.value).toString())
        onChange(e.target.value);
    }
    return (
        <Grid container spacing={2}>
            <Grid item >
                <DateInput  label={props.label+" GC"} source={name} onChange={convertToEC}  options={{ format: 'DD/MM/YY' }} style={{ display: 'inline', width:"100%", float: 'left'}} />

            </Grid>
            <Grid item >
            <TextField placeholder="YYYY-MM-DD" margin="dense" label={props.label+" Ethiopian C"} value={ecDate} onChange={e=>setEcDate(e.target.value)}  onBlur={convertToGC}  />
            </Grid>
        </Grid>
    );
};

export default EthiopianDateInput;
